import React from 'react';
import SelectInput, { isValid } from './SelectInput';
import { EventInfo } from './Types';

const valueGetter = (event: EventInfo) => event.event_id
const nameGetter = (event: EventInfo) => `${event.name} ${event.date} (${event.type})`

function EventorEventSelect({events, value, onChange, required, ...props}: {
  events: EventInfo[],
  value: number | null,
  onChange: (newValue: number) => void,
  required: boolean
}) {
  return (
    <SelectInput
      label='Arrangemang'
      value={value}
      options={events}
      valueGetter={valueGetter}
      nameGetter={nameGetter}
      onChange={onChange}
      required={required}
      {...props}
    />
  )
}

export function isValidEvent({eventId, events}: {eventId: number, events: EventInfo[]}) {
  return isValid({value: eventId, options: events, valueGetter: valueGetter})
}

export default EventorEventSelect
